import { render, staticRenderFns } from "./VDesigningGroupsList.vue?vue&type=template&id=7ddc305f&"
import script from "./VDesigningGroupsList.vue?vue&type=script&lang=ts&"
export * from "./VDesigningGroupsList.vue?vue&type=script&lang=ts&"
import style0 from "./VDesigningGroupsList.vue?vue&type=style&index=0&id=7ddc305f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports